import { ChevronIcon } from "../../../../materials/icons/chevron-icon/ChevronIcon";
import { DismissIcon } from "../../../../materials/icons/dismiss-icon/DismissIcon";
import { IconButton } from "../../../icon-button/IconButton.Parts";
import {
  Content,
  LabelContainer,
  Placeholder,
  ToggleButtonContainer,
} from "../Trigger.Parts";
import {
  Props,
  SelectionContainer,
  SelectionLabel,
} from "./SingleSelectContent.Parts";

/**
 * Renders the content inside a single select trigger, including the
 * label, placeholder, selected value, search input, and action buttons.
 */
export const SingleSelectContent = ({
  rows,
  hasContent,
  label,
  searchInputId,
  placeholder,
  selection,
  getLabelForValue,
  search,
  clearSelection,
  buttonRef,
  disabled,
  clearable,
  context,
  referenceId,
  searchInput,
  name,
}: Props) => (
  <>
    <Content
      $rows={rows}
      $multi={false}
      $active={hasContent || (context.open && search)}
    >
      {label && (
        <LabelContainer
          $smallLabel={
            hasContent || selection.length > 0 || (context.open && search)
          }
        >
          <label htmlFor={search ? searchInputId : referenceId}>{label}</label>
        </LabelContainer>
      )}
      {placeholder && selection.length === 0 && !search && (
        <Placeholder>{placeholder}</Placeholder>
      )}
      <SelectionContainer>
        {selection.length > 0 && (!context.open || !search) && (
          <SelectionLabel>{getLabelForValue(selection[0])}</SelectionLabel>
        )}
        {search && (context.open || selection.length === 0) && searchInput}
      </SelectionContainer>
    </Content>
    <ToggleButtonContainer $rows={rows > 1}>
      {selection.length > 0 && clearable ? (
        <IconButton
          type="button"
          onClick={(e) => {
            clearSelection(e);
            buttonRef.current?.focus({ preventScroll: true });
          }}
          onKeyDown={(e) => e.stopPropagation()}
          $small
          disabled={disabled}
        >
          <DismissIcon small />
        </IconButton>
      ) : (
        <IconButton type="button" tabIndex={-1} $small disabled={disabled}>
          <ChevronIcon orientation={context.open ? "up" : "down"} />
        </IconButton>
      )}
    </ToggleButtonContainer>
    <input type="hidden" name={name} value={selection[0] ?? ""} />
  </>
);
